<div *transloco="let t" class="container flex text-center justify-content-center align-items-center">
  <div class="flex flex-column text-center justify-content-center align-items-center">
    <img src="browser.png" alt="404 image" draggable="false" height="130">
    <div>
      <h1 class="mb-2">{{ title }}</h1>
      <p [innerHTML]="message"></p>
      <p-button (onClick)="router.navigate(['/'])" [label]="t('back_home') | uppercase"></p-button>
    </div>
  </div>
</div>
